import React from "react";

export default function SQLServer_AVG() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_AVG</h1>
      <p>This is the SQLServer_AVG component generated from the SQL JSON.</p>
    </div>
  );
}
